import { render, staticRenderFns } from "./All-Transactions.vue?vue&type=template&id=156aa06a&scoped=true"
import script from "./All-Transactions.vue?vue&type=script&lang=js"
export * from "./All-Transactions.vue?vue&type=script&lang=js"
import style0 from "./All-Transactions.vue?vue&type=style&index=0&id=156aa06a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "156aa06a",
  null
  
)

export default component.exports